import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { Observable } from 'rxjs';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';

import { Prodmaecentra } from "../prodinterfaces/prodmaecentra";


@Injectable({
  providedIn: 'root'
})
export class ProdmaecentrbajoService {
  public way: string;

  get prodmaecentrab(): Prodmaecentra[] {
    return this._prodmaecentrab;
  }

  set prodmaecentrab(value: Prodmaecentra[]) {
    this._prodmaecentrab = value;
  }
  private _prodmaecentrab: Prodmaecentra[];

  constructor(
    private http: HttpClient,
    private confIniciales: ConfInicialesService,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario
  ) {
    this.way = sessionStorage.getItem('way');
  }

  getcentrab() {
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/10776ca731d7ef000', {
      elementos: {},
    }, this.confIniciales.httpOptions()).toPromise();

  }
  actualizarcentrab(item) {
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/a6758ebf76a5a800', {
      elementos: {
        p_centra_codigo :item.CENTRA_CODIGO,
        p_centra_descripcion :item.CENTRA_DESCRIPCION,
        p_com_codigo :item.COM_CODIGO
      },
    }, this.confIniciales.httpOptions()).toPromise();

  }
  insertarcentrab(item) {
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/257e3b7d56d8ec0000', {
      elementos: {
        p_centra_codigo :item.CENTRA_CODIGO,
        p_centra_descripcion :item.CENTRA_DESCRIPCION,
        p_com_codigo :item.COM_CODIGO
      },
    }, this.confIniciales.httpOptions()).toPromise();

  }
  frcentrab(codigo){
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/41dd63afdda99800000', {
      elementos: {
        centra_cod :codigo,
      },
    }, this.confIniciales.httpOptions());
  }
  consulcentra(codigo){
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/3317e7aac75fbc00000', {
      elementos: {
        centra_cod :codigo,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarcentrab(codigo){
    return this.http.post<any[]>(this.way + '/produccion/prodmacentra/1d595a57531d7f0000', {
      elementos: {
        p_centra_codigo :codigo,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
